import { checkFileFormat, getFileType } from './checkFileFormat';
import { gray, green, orange, purple, blue } from '../style/colors';

interface TagProps {
  text: string;
  [key: string]: any;
}

interface IconLogoFinderProps {
  type: string;
  format?: string;
  tags?: Array<TagProps>;
}

export const ItemCategoryFinder = (props: IconLogoFinderProps) => {
  return props.type === 'link'
    ? 'link'
    : props.type === 'folder'
      ? 'folder'
      : props.type === 'document' && props?.format === 'quill'
        ? 'document'
        : props.type === 'document'
          ? getFileType(props.format as string)
          : props.type === 'surveyReport'
            ? 'report'
            : props.type === 'survey'
              ? props.tags &&
                props?.tags?.filter((value) => value?.text === 'شاخص')?.length >
                  0
                ? 'shakhes'
                : 'survey'
              : props.type === 'externalLink'
                ? 'exLink'
                : props.type === 'searchTag'
                  ? 'smartFolder'
                  : 'folder';
};

export const IconLogoFinder = (props: IconLogoFinderProps) => {
  return props.type === 'link'
    ? 'user.svg'
    : props.type === 'folder'
      ? 'zip.svg'
      : props.type === 'document' && props?.format === 'quill'
        ? 'document.svg'
        : props.type === 'document'
          ? checkFileFormat(props.format as string)
          : props.type === 'surveyReport'
            ? 'presention-chart.svg'
            : props.type === 'survey'
              ? props.tags &&
                props?.tags?.filter((value) => value?.text === 'شاخص')?.length >
                  0
                ? 'survey-shakhes.svg'
                : 'survey.svg'
              : props.type === 'externalLink'
                ? 'link.svg'
                : props.type === 'searchTag'
                  ? 'folder-search.svg'
                  : 'zip.svg';
};

export const IconColorFinder = (type: string) => {
  return type === 'link'
    ? gray
    : type === 'folder' || type === 'searchTag'
      ? orange
      : type === 'document'
        ? blue
        : type === 'surveyReport'
          ? green
          : type === 'survey'
            ? purple
            : blue;
};
